module.exports = __webpack_public_path__ + "img/tech 2.89ee8220.png";